module.exports = __webpack_public_path__ + "img/logo-20.eef96c0.jpg";